var md = new MobileDetect(window.navigator.userAgent);
var ua = detect.parse(navigator.userAgent);

var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;

var ismobile = false;
var openMega = null;
var currentPage = 1;
var blogfilter = null;

if (md.mobile())
    ismobile = true;




// Define the Function targetBlank()
function targetBlank() {
    // remove subdomain of current site's url and setup regex
    let internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");

//    let a = document.getElementsByTagName('a'); // then, grab every link on the page
    let a = document.querySelectorAll('a:not([target=_blank])');
    const alen = a.length;
    for (let i = 0; i < alen; i++) {
        let host = a[i].host; // set the host of each link
        let href = a[i].getAttribute("href"); // set the host of each link
        let isLocal = internal.test(host);
        let isHubspot = /^sites.algeco.de/.test(host);
        let isJs = /^javascript/.test(href);
        let isPdf = /\.pdf$/.test(href);

        if ((!isLocal && !isJs) || isPdf || isHubspot) { // make sure the href doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
        }
    }
}
function getCORS(url, success) {
    var xhr = new XMLHttpRequest();
    if (!('withCredentials' in xhr)) xhr = new XDomainRequest(); // fix IE8/9
    xhr.open('GET', url);
    xhr.onload = success;
    xhr.send();
    return xhr;
}
/*
function addCopyrightInfo() {
    let copyHolder = document.querySelectorAll('[data-copyright-source]:not([data-copyright-source=""])');
    if (copyHolder) {
        copyHolder.forEach((el) => {
            let newElement = document.createElement('div');
            newElement.className = 'copy-sign';
            newElement.setAttribute('aria-haspopup', 'true');
            let span = document.createElement('span');
            let label = document.createElement('label');
            label.textContent = el.dataset.copyrightSource;
            let mark = document.createElement('mark');
            mark.textContent = el.dataset.copyrightCreator;
            span.appendChild(label);
            span.appendChild(mark);
            newElement.appendChild(span);
            if ('IMG' == el.nodeName) {
                el.parentNode.prepend(newElement);
            } else {
                el.appendChild(newElement);
            }

            newElement.addEventListener('click', function (evt) {
                evt.preventDefault();
                console.log(evt.target);
            });
            
        });
    }
}
*/
function loadMore(event) {
    event.preventDefault();
    var lb = document.querySelectorAll(".load-more");
    lb.forEach((btn) => {
        btn.innerHTML = "laden..";
    });
    getCORS('/info-center/newsroom/more/?page=' + currentPage, function (request) {
        var response = request.currentTarget.response || request.target.responseText;
//        console.log(response);
        var lb = document.querySelectorAll(".load-more");
        lb.forEach((btn) => {
            btn.style.display = 'none';
        });
        currentPage++
        var target = document.querySelector(".section-news .item-holder");
        target.innerHTML += response + '    <div class="text-center mb-3 mt-5 col-12">\n' +
            '                    <button class="btn btn-primary load-more load-more-' + currentPage + '">Weitere News laden</button>\n' +
            '                </div>';

        setTimeout(function () {
            var lb2 = document.querySelectorAll(".load-more-" + currentPage)[0];
            if (lb2) {
                lb2.onclick = function (e) {
                    loadMore(e)
                };
            }
        }, 100)

    });

}

function loadMore2(event) {
    event.preventDefault();
    var lb = document.querySelectorAll(".load-more2");
    lb.forEach((btn) => {
        btn.innerHTML = "laden..";
    });
    var $url = '/blog/more/?mpage=' + currentPage;
    if (blogfilter)
        $url = '/blog/more/?filter=' + blogfilter + '&mpage=' + currentPage;

    console.log($url)
    getCORS($url, function (request) {
        var response = request.currentTarget.response || request.target.responseText;
//        console.log(response);
        var lb = document.querySelectorAll(".load-more2");
        lb.forEach((btn) => {
            btn.style.display = 'none';
        });
        currentPage++
        var target = document.querySelector(".section-news .item-holder");
        target.innerHTML += response + '    <div class="text-center mb-3 mt-5 col-12">\n' +
            '                    <button class="btn btn-primary load-more2 load-more-' + currentPage + '">Weitere laden</button>\n' +
            '                </div>';

        setTimeout(function () {
            var lb2 = document.querySelectorAll(".load-more-" + currentPage)[0];
            if (lb2) {
                lb2.onclick = function (e) {
                    loadMore2(e)
                };
            }
        }, 100)

    });

}

function loadFilter(event, filter) {
    event.preventDefault();
    var lb = document.querySelectorAll(".load-more2");
    lb.forEach((btn) => {
        btn.innerHTML = "laden..";
    });
    blogfilter = filter;
    var $url = '/blog/more/?mpage=' + 0;
    if (blogfilter)
        $url = '/blog/more/?filter=' + filter + '&mpage=' + 0;


    getCORS($url, function (request) {
        var response = request.currentTarget.response || request.target.responseText;
//        console.log(response);
        var lb = document.querySelectorAll(".load-more2");
        lb.forEach((btn) => {
            btn.style.display = 'none';
        });
        var target = document.querySelector(".section-news .item-holder");
        target.innerHTML = response + '    <div class="text-center mb-3 mt-5 col-12">\n' +
            '                    <button class="btn btn-primary load-more2 load-more-' + currentPage + '">Weitere laden</button>\n' +
            '                </div>';

        setTimeout(function () {
            var lb2 = document.querySelectorAll(".load-more-" + currentPage)[0];
            if (lb2) {
                lb2.onclick = function (e) {
                    loadMore2(e)
                };
            }
        }, 100)

    });

}

function checkItems(gl) {
    if (gl.slides_count <= gl.settings.perView) {
        gl.update({startAt: 0}).disable();
        gl.elem.querySelectorAll('.glide__arrows').forEach((el) => {
            el.classList.add('d-none')
        });
        gl.elem.querySelectorAll('.glide__bullets').forEach((el) => {
            el.classList.add('d-none')
        });
        gl.elem.classList.add('no-margin-bottom')
    } else {
        gl.enable();
        gl.elem.querySelectorAll('.glide__arrows').forEach((el) => {
            el.classList.remove('d-none')
        });
        gl.elem.querySelectorAll('.glide__bullets').forEach((el) => {
            el.classList.remove('d-none')
        });
        gl.elem.classList.remove('no-margin-bottom')
    }
}

function checkItems2(gl) {
    if (gl.slides_count <= gl.settings.perView) {
        gl.elem.querySelectorAll('.glide__arrows2').forEach((el) => {
            el.classList.add('d-none')
        });
    }
}

function updateFilter() {
    var currentFilter = [];
    document.querySelectorAll(".filter-buttons .btn").forEach((btn) => {
        if (btn.classList.contains("active"))
            currentFilter.push(btn.getAttribute('data-filter'));
    });
    var $count = 0;

    document.querySelectorAll(".filter-item-container .filter-empty").forEach((item) => {
        item.classList.remove('show');
    });
    document.querySelectorAll(".filter-item-container .filter-item").forEach((item) => {
        // console.log(currentFilter.every(e => item.classList.contains(e)))
        if (item.classList.contains('multi')) {
            if (currentFilter.length === 0 || currentFilter.some(e => item.classList.contains(e))) {
                item.classList.remove('hide');
                $count++;
            } else
                item.classList.add('hide');
        } else {
            if (currentFilter.length === 0 || currentFilter.every(e => item.classList.contains(e))) {
                item.classList.remove('hide');
                $count++;
            } else
                item.classList.add('hide');
        }

    });
    if ($count == 0) {
        document.querySelectorAll(".filter-item-container .filter-empty").forEach((item) => {
            item.classList.add('show');
        });
    }
}

let loaderCount = -1;
let preImgs = document.querySelectorAll("img.al-preload");
if (preImgs.length > 0) {
    loaderCount = 0;
    preImgs.forEach((img) => {
        loaderCount++;
        let t = new Image();
        img.addEventListener('load', function () {
            loaderCount--;
            if (loaderCount == 0) {
                document.body.classList.remove('al-preloading');
            }
        }, false);
        t.src = img.src;
        img.src = t.src;
    });
}

//stoerer
function hideStoerer() {
    Cookies.set('stoerer', 'no', { expires: 1 })
    stoerer.classList.remove('show')
    document.querySelector('footer').style.paddingBottom= '0';
}

// stoerer
let stoerer = document.querySelector('.stoerer');

if (stoerer) {

    let btnC = stoerer.querySelector('.closeX');
    btnC.addEventListener('click', function (e) {
        hideStoerer();
    })
    // let btnC2 = stoerer.querySelector('.close2');
    // btnC2.addEventListener('click', function (e) {
    //     hideStoerer();
    // })
}


document.addEventListener('DOMContentLoaded', function () {
    "use strict";

    targetBlank();
    if (document.querySelectorAll("button.navbar-toggler").length > 0) {
        // Mobile toggler
        document.querySelectorAll("button.navbar-toggler")[0].addEventListener("click", function (event) {
            var target = this.getAttribute("data-target");
            var subbar = document.querySelectorAll(target)[0];
            subbar.className = (subbar.className + " nav-is-toggled").replace(/ nav-is-toggled nav-is-toggled/, "");
            this.className = (this.className + " open").replace(/ open open/, "");
        });
    }

    // Mobile Menu
    const navExpand = [].slice.call(document.querySelectorAll('.nav-expand'));
    const backLink = `<li class="nav-item">
  <a class="nav-link nav-back-link" href="javascript:;"> zurück </a>
  </li>`;

    navExpand.forEach(item => {
        item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', backLink);
        item.querySelector('.nav-link').addEventListener('click', () => item.classList.add('active'));
        item.querySelector('.nav-back-link').addEventListener('click', () => item.classList.remove('active'));
    });

    // Mega Menu Darken
    document.querySelectorAll('.content-darker')[0].addEventListener("mouseover", function (event) {
        if (openMega.classList.contains("open")) {
            openMega.classList.remove("open");
            this.classList.remove("show");
        }
    });

    // Mega Menu Open
    document.querySelectorAll(".navbar .nav-item .nav-link").forEach(link => link.addEventListener("click", function (event) {
        event.preventDefault();
        var elm = this.parentNode;
        var target = elm.getAttribute("data-target");
        //console.log(this);
        var darker = document.querySelectorAll('.content-darker')[0];

        if (!elm.classList.contains("open")) {
            elm.classList.add("open");
            if (openMega && openMega !== elm) {
                openMega.classList.remove("open");
            }
            if (!darker.classList.contains("show")) {
                darker.classList.add("show");
            }
            openMega = elm;
        } else {
            //this.classList.remove("open");
            //darker.classList.remove("show");
        }
    }));

    // Initialize Overlay Popups
    let overlayCloseButtons = document.querySelectorAll(".mk-fullscreen-close");
    overlayCloseButtons.forEach(btn => {
        btn.addEventListener('click', function (evt) {
            evt.preventDefault();
            let parent = evt.target.parentElement;
            parent.classList.remove("mk-fullscreen-overlay-show");
            console.log(parent);
            if (parent.getAttribute('id') == 'mk-video-overlay') {
                console.log('close video overlay');
                OvPlayer.pause();
                OvPlayer.currentTime(0);
                OvPlayer.hasStarted(false);
            }
        });
    });





    //stoerer
    if (document.querySelectorAll(".stoerer").length > 0) {
        let cookie = Cookies.get('stoerer');
        if(cookie === 'no'){
            stoerer.classList.add('hide')
        }else{

            document.querySelector('footer').style.paddingBottom = stoerer.offsetHeight + 24 + 'px';

            stoerer.classList.add('show')
        }
    }

    let popupBtns = document.querySelectorAll('a[data-popup]');
    popupBtns.forEach(btn => {
        btn.addEventListener('click', function (evt) {
            evt.preventDefault();
            let popup = document.getElementById(this.getAttribute('data-popup'));
            if (popup) {
                popup.classList.add('mk-fullscreen-overlay-show');
            } else {
                console.error('Popup not found: ' + this.getAttribute('data-popup'));
            }
        });
    });

    /* Init video player popup */
    try {
        const OvPlayer = videojs('overlay-video-player');
        let videos = document.querySelectorAll('a[href*="youtube"], a[href*="vimeo"]');
        if (videos.length > 0) {
            videos.forEach((video, i) => {
                video.addEventListener("click", function(evt) {
                    evt.preventDefault();
                    const url = evt.target.href;
                    // Open video player overlay
                    let popup = document.getElementById('mk-video-overlay');
                    if (popup) {
                        let type = 'video/mp4';
                        if (url.includes('youtube')) {
                            type = 'video/youtube';
                        }
                        OvPlayer.src({type: type, src: url});
                        popup.classList.add('mk-fullscreen-overlay-show');
                    } else {
                        console.error('Popup not found: ' + this.getAttribute('data-popup'));
                    }
                });
            });
        }
    } catch (exception) {
        console.log(exception);
    }

    // online form btn
    var form = document.querySelectorAll(".contact-form")[0];
    var bt = document.querySelectorAll(".btn-onlineform")[0];
    //If it isn't "undefined" and it isn't "null", then it exists.
    if (typeof (form) !== 'undefined' && form != null) {
        bt.classList.add("d-none");
    }

    // Init Smart menu Sliders
    document.querySelectorAll('.glide-smart').forEach((elem) => {
        // console.log('mount');
        new Glide(elem, {
            perView: 6,
            gap: 5,
            type: 'slider',
            bound: true,
            breakpoints: {
                993: {
                    perView: 4
                },
                800: {
                    perView: 3
                },
                600: {
                    perView: 2
                },
                400: {
                    perView: 2
                }
            }
        }).mount()
    });

    // Init Aktuell Sliders
    document.querySelectorAll('.glide-aktuell').forEach((elem) => {
        // console.log('mount2');
        var slides_count = document.querySelectorAll('.glide-aktuell .glide__slide').length;
        var type = 'carousel';
        if (slides_count < 3)
            type = 'slider';
        var gl = new Glide(elem, {
            perView: 3,
            gap: 20,
            type: type,
            bound: true,
            breakpoints: {
                993: {
                    perView: 2
                },
                800: {
                    perView: 2
                },
                600: {
                    perView: 1
                },
                400: {
                    perView: 1
                }
            }
        });
        gl.slides_count = slides_count;
        gl.elem = elem;
        gl.on('mount.after', function () {
            checkItems(gl)
        });
        gl.on('resize', function () {
            checkItems(gl)
        });

        gl.mount()
    });

    // Init projekbilder Sliders
    document.querySelectorAll('.glide-projectimages').forEach((elem) => {
        // console.log('mount2');
        var gl = new Glide(elem, {
            perView: 1,
            gap: 0,
            type: 'slider',
            bound: true,
        });
        gl.slides_count = elem.querySelectorAll('.glide__slide').length;
        gl.elem = elem;
        gl.on('mount.after', function () {
            checkItems(gl)
        });
        gl.on('resize', function () {
            checkItems(gl)
        });
        gl.mount()
    });

    // Init Menschen Sliders
    document.querySelectorAll('.glide-menschen').forEach((elem) => {
        // console.log('mount2');
        var gl = new Glide(elem, {
            perView: 1,
            gap: 0,
            type: 'slider',
            bound: true,
        });
        gl.slides_count = elem.querySelectorAll('.glide__slide').length;
        gl.elem = elem;
        gl.on('mount.after', function () {
            checkItems(gl)
        });
        gl.on('resize', function () {
            checkItems(gl)
        });
        gl.mount()
    });

    // Init pakete Sliders
    document.querySelectorAll('.glide-pakete').forEach((elem) => {
        // console.log('mount2');

        var slides_count = document.querySelectorAll('.glide-pakete .glide__slide').length;
        var type = 'carousel';
        if (slides_count < 3)
            type = 'slider';
        var gl = new Glide(elem, {
            perView: 3,
            gap: 20,
            type: type,
            bound: true,
            breakpoints: {
                993: {
                    perView: 2
                },
                800: {
                    perView: 2
                },
                600: {
                    perView: 1
                },
                400: {
                    perView: 1
                }
            }
        });
        gl.slides_count = slides_count;
        gl.elem = elem;
        gl.on('mount.after', function () {
            checkItems(gl)
            setBtns(gl.elem)
        });
        gl.on('resize', function () {
            checkItems(gl)
        });
        gl.on('run.after', function () {
            setBtns(gl.elem)
        });
        gl.mount()
    });

    function setBtns (gl){
        gl.querySelectorAll('.glightboxBtn').forEach((btn) => {
            btn.onclick = function (e) {
                e.preventDefault();
                console.log(btn)
                let myGallery = GLightbox({
                    elements: [
                        {
                            'href': $(btn).data('file'),
                            'type': 'image',
                            'title': $(btn).data('title')
                        }
                    ]
                });
                myGallery.open();
            }

        })
    }

    // Init Broschueren Slider
    document.querySelectorAll('.glide-broschueren').forEach((elem) => {
        // console.log('mount2');
        var gl = new Glide(elem, {
            perView: 4,
            gap: 30,
            type: 'slider',
            bound: true,
            breakpoints: {
                993: {
                    perView: 3
                },
                600: {
                    perView: 2
                },
                450: {
                    perView: 1
                }
            }
        });
        gl.slides_count = elem.querySelectorAll('.glide__slide').length;
        gl.elem = elem;
        gl.on('mount.after', function () {
            checkItems(gl)
        });
        gl.on('resize', function () {
            checkItems(gl)
        });
        gl.mount()
    });

    // Init images Sliders
    document.querySelectorAll('.glide-images').forEach((elem) => {
        // console.log('mount2');
        var gl = new Glide(elem, {
            perView: 1,
            gap: 0,
            type: 'slider',
            bound: false,
            swipeThreshold: false,
            keyboard: false,
            animationDuration: 0,
            classes: {
                direction: {
                    ltr: 'glide--ltr2',
                    rtl: 'glide--rtl2'
                },
                slider: 'glide--slider2',
                carousel: 'glide--carousel2',
                swipeable: 'glide--swipeable2',
                dragging: 'glide--dragging2',
                cloneSlide: 'glide__slide--clone2',
                activeNav: 'glide__bullet--active2',
                activeSlide: 'glide__slide--active2',
                disabledArrow: 'glide__arrow--disabled2'
            }
        });

        gl.slides_count = elem.querySelectorAll('.glide__slide').length;
        gl.elem = elem;
        gl.on('mount.after', function () {
            // Logic fired after mounting
            // console.log('mount.after');
            var rb = elem.querySelectorAll('.glide__arrow--right')[0];
            rb.onclick = function () {
                gl.go('>')
            };
            var lb = elem.querySelectorAll('.glide__arrow--left')[0];
            lb.onclick = function () {
                gl.go('<')
            };
            checkItems2(gl);
        });
        gl.mount()
    });

    // scrollto buttons
    document.querySelectorAll('.anchor').forEach((btn) => {
        let db = btn;
        db.onclick = function (e) {
            e.preventDefault();
            let elm = document.querySelectorAll(db.getAttribute("href"))[0];
            document.querySelectorAll('.open-text.open').forEach((o) => {
                o.classList.remove('open');
            });

            window.setTimeout(function () {
                window.scrollTo({
                    'behavior': 'smooth',
                    'left': 0,
                    'top': elm.offsetTop - 160
                });
                elm.classList.add("open");
            }, 600);
        };
    });

    // accordion
    let acc = document.getElementsByClassName('accordion');
    let i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener('click', function() {
            this.classList.toggle('active');
            let panel = this.nextElementSibling;
            console.log(parent[0])

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
            }
        });
    }

    // load more btn
    var lb = document.querySelectorAll(".load-more")[0];
    if (lb) {
        lb.onclick = function (e) {
            loadMore(e)
        };
    }

    var lb2 = document.querySelectorAll(".load-more2")[0];
    if (lb2) {
        lb2.onclick = function (e) {
            loadMore2(e)
        };
    }

    /*
      // detail buttons standorte
      document.querySelectorAll('.btn-standort-detail').forEach((btn) => {
        var db = btn;
        db.onclick = function (e) {
          console.log('click');
          e.preventDefault();
          if (db.closest('.standorte-item-container').classList.contains("big")) {
            db.closest('.standorte-item-container').classList.remove("big");
          } else {
            db.closest('.standorte-item-container').classList.add("big");
          }
        };
      });
    */
    // detail buttons
    document.querySelectorAll('.btn-detail').forEach((btn) => {
        var db = btn;
        db.onclick = function () {
            console.log('click');
            if (db.closest('.open-text').classList.contains("open")) {
                db.closest('.open-text').classList.remove("open");
            } else {
                db.closest('.open-text').classList.add("open");
            }
        };
    });
    document.querySelectorAll('.questions li h5:not(.no-open)').forEach((btn) => {
        var db = btn;
        db.onclick = function () {
            if (db.closest('.open-text').classList.contains("open")) {
                db.closest('.open-text').classList.remove("open");
            } else {
                db.closest('.open-text').classList.add("open");
            }
        };
    });
    document.querySelectorAll('.questions li h4:not(.no-open)').forEach((btn) => {
        var db = btn;
        db.onclick = function () {
            if (db.closest('.open-text').classList.contains("open")) {
                db.closest('.open-text').classList.remove("open");
            } else {
                db.closest('.open-text').classList.add("open");
            }
        };
    });

    // parallax
    var ph = 3000;
    document.querySelectorAll('.parallax-scene').forEach((elem) => {
        const modifier = elem.getAttribute('data-modifier');
        let start = elem.offsetTop - y;
        const to = start + ph;
        if (start < 0)
            start = 0;
        // console.log("start " +start);
        let modifierR = modifier * (x / 1000);
        basicScroll.create({
            elem: elem,
            from: start,
            to: to,
            direct: true,
            props: {
                '--translateY': {
                    from: '0',
                    to: `${4 * modifierR}px`
                }
            }
        }).start()
    });

    // filter buttons
    document.querySelectorAll(".filter-buttons").forEach((btns) => {
        var dbs = btns;
        dbs.querySelectorAll(".btn").forEach((btn) => {
            var db = btn;
            db.onclick = function (e) {
                if (this.getAttribute('data-blogfilter')) {
                    if (this.classList.contains('active')) {
                        this.classList.remove('active');
                        blogfilter = null;
                        currentPage = 0;
                        loadFilter(e, null);
                    } else {
                        if (!dbs.classList.contains('multi')) {
                            dbs.querySelectorAll(".btn").forEach((bt) => {
                                bt.classList.remove('active')
                            });
                        }
                        loadFilter(e, this.getAttribute('data-blogfilter'))
                        this.classList.add('active');
                    }

                } else {
                    if (this.classList.contains('active')) {
                        this.classList.remove('active');
                    } else {
                        if (!dbs.classList.contains('multi')) {
                            dbs.querySelectorAll(".btn").forEach((bt) => {
                                bt.classList.remove('active')
                            });
                        }
                        this.classList.add('active');
                    }
                    updateFilter();
                }
                if (this.getAttribute('data-check')) {
                    document.querySelectorAll('.' + this.getAttribute('data-check') + " .btn").forEach((b) => {
                        var cl = document.querySelectorAll(".filter-item-container ." + b.getAttribute('data-filter'));
                        if (this.classList.contains('active'))
                            cl = document.querySelectorAll(".filter-item-container ." + b.getAttribute('data-filter') + '.' + this.getAttribute('data-filter'));
                        //console.log(cl);
                        if (cl.length < 1) {
                            b.classList.add('disabled');
                        } else {
                            b.classList.remove('disabled');
                        }
                    });
                }
            };
        });
    });

    // accordion buttons
    document.querySelectorAll(".accordion-buttons").forEach((btns) => {
        var dbs = btns;
        dbs.querySelectorAll(".btn").forEach((btn) => {
            var db = btn;
            db.onclick = function () {

                if (this.getAttribute('data-sync')) {
                    document.querySelectorAll("." + this.getAttribute('data-sync') + ' .btn').forEach((bt) => {
                        bt.classList.remove('active');
                        if (bt.classList.contains('accordion-button-' + this.getAttribute('data-btn'))) {
                            bt.classList.add('active');
                        }
                    });
                }

                if (this.classList.contains('active')) {
                    this.classList.remove('active');
                } else {
                    dbs.querySelectorAll(".btn").forEach((bt) => {
                        bt.classList.remove('active')
                    });
                    this.classList.add('active');
                    var cont = document.querySelector('.' + dbs.getAttribute('data-container'));
                    cont.querySelectorAll("div").forEach((div) => {
                        if (div.classList.contains(db.getAttribute('data-filter'))) {
                            //div.classList.add('open')
                        } else {
                            div.classList.remove('open')
                        }
                    });
                    cont.querySelectorAll("div").forEach((div) => {
                        if (div.classList.contains(db.getAttribute('data-filter'))) {
                            div.classList.add('open')
                        }
                    });
                }
            };
        });
    });

    if (true || loaderCount == -1) {
        document.body.classList.remove('al-preloading');
    }

    if (window.location.hash) {
        const hash = window.location.hash;
        let elm = document.getElementById(hash.substring(1));
        if (elm && elm.closest('.open-text')) {
            elm.closest('.open-text').classList.add("open");
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': elm.offsetTop - 130
            });
        }
    }

    // ZenScroll: scroll to ancor
    const nav = document.getElementById('mainNav');
    const defaultDuration = 777; // ms
    const edgeOffset = nav.offsetHeight; // px
    zenscroll.setup(defaultDuration, edgeOffset);

    document.querySelectorAll('a[data-anchor]').forEach((btn) => {
        console.log(btn);
        btn.onclick = function (evt) {
            evt.preventDefault();
            let anchor = this.getAttribute('data-anchor').replace('#','');
            //document.getElementById(anchor);
            zenscroll.to(document.getElementById(anchor));
        }
    });


}, false);

// navbar shrink

window.addEventListener('scroll', function handleScroll(event) {
    const nav = document.getElementById("mainNav");
    if (window.scrollY < 0) return; // Prevent hiding on apple overscroll
    if (window.scrollY > this.lastScrollTop || 0) {
        nav.classList.add("shrink");
    } else if (window.scrollY < this.lastScrollTop) {
        nav.classList.remove("shrink");
    }

    this.lastScrollTop = window.scrollY;
});
